export default __webpack_public_path__ + "static/button-label-dont-light-fbe6f9cdd1562ff9b4a3dd15c829f47d.png";